import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {ReportLayoutComponent} from './report-layout/report-layout.component'
import {CertificateReportComponent} from './certificate-report/certificate-report.component'
import {PrintCertificateComponent} from './print-certificate/print-certificate.component'
import { DealerAggregatedReportComponent } from './dealer-aggregated-report/dealer-aggregated-report.component';
import { DealerBalanceReportComponent } from './dealer-balance-report/dealer-balance-report.component';
import { PaymentPayoutReportComponent } from './payment-payout-report/payment-payout-report.component';
import { TotalBalanceReportComponent } from './total-balance-report/total-balance-report.component';
import { EndorsementReportComponent } from './endorsement-report/endorsement-report.component';

const routes: Routes = [
  {
      path: '', component: ReportLayoutComponent,
      children: [
          { path: 'certificateReport', component: CertificateReportComponent },
          { path: 'certificateReport/:id', component: CertificateReportComponent },
          { path: 'printCertificate',component: PrintCertificateComponent},
          { path: 'renewCertificate',component: PrintCertificateComponent},
          { path: 'dealerAggregateReport',component: DealerAggregatedReportComponent},
          { path: 'dealerBalanceReport',component: DealerBalanceReportComponent},
          { path: 'transactionReport', component: PaymentPayoutReportComponent}
          ,{ path: 'totalBalanceReport', component: TotalBalanceReportComponent}
          ,{ path: 'requestCertificate', component: PrintCertificateComponent}
          ,{path:'endorsementReport',component:EndorsementReportComponent}

      ]
  }
];



@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule { }
